import LargeLabel from './LargeLabel';

export default LargeLabel;
export * from './LargeLabel';
